import Vue from 'vue'
import App from './App.vue'
import { traductions } from './text.js'
import router from './router'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import MSStreamAuth from '@/auth/auth.js';
import VueClipboard from 'vue-clipboard2';
import store from './store/store';
import JsonCSV from 'vue-json-csv';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBan, faNetworkWired, faClipboardList, faSignal, faHistory, faCreditCard, faWifi, faDesktop, faExclamation, faStopCircle, faPauseCircle, faPause, faMedal, faExternalLinkSquareAlt, faImage, faShare, faCut, faLevelDownAlt, faEnvelope, faBackward, faCircle as fasCircle, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faDotCircle, faUnlink, faKey, faUserTimes, faUserPlus, faCode, faIdCardAlt, faIdBadge, faLock, faLockOpen, faDiceOne, faUserTie, faUserFriends, faInfoCircle, faHandPaper, faHandRock, faTools, faCommentDots, faComments, faProjectDiagram, faShoppingCart, faMinus, faAngleDown, faAngleUp, faEyeSlash, faCheckCircle, faCalendarWeek, faCalendarMinus, faCaretRight, faCaretDown, faUpload, faArrowUp, faFileUpload, faWindowClose, faCaretLeft, faReplyAll, faLevelUpAlt, faThList, faMinusSquare, faTimes, faPenSquare, faCaretSquareUp, faArrowCircleUp, faCheck, faCheckSquare, faMinusCircle, faSlash, faTrash, faEnvelopeOpen, faTag, faBell, faFileExport, faBoxOpen, faBookReader, faBookOpen, faArrowAltCircleDown, faDownload, faListOl, faCircleNotch, faLongArrowAltDown, faFileAlt, faClipboard, faEdit, faUserEdit, faPen, faTags, faClock, faStopwatch, faHourglassHalf,faHourglassEnd, faEye, faWater, faFire, faPlus, faPlug, faExternalLinkAlt, faLeaf, faDatabase, faUsers, faSpinner, faThumbsUp, faFilm, faSync, faSort, faStream, faArrowLeft, faRetweet, faRedo, faRedoAlt, faCog, faMicrophoneSlash, faMicrophone, faVolumeUp, faVolumeMute, faLink, faPencilAlt, faFileVideo, faCloudUploadAlt, faBars, faTh, faList, faSortAlphaUp, faSortAlphaDown, faSortNumericUp, faSortNumericDown, faStop, faCogs, faTrashAlt, faExclamationCircle, faVideo, faSearch, faAngleDoubleDown, faAngleDoubleUp, faUser, faPlay, faChartLine, faSignOutAlt, faSignInAlt, faQuestionCircle, faExclamationTriangle, faClone, faHighlighter } from '@fortawesome/free-solid-svg-icons'
import { faComment, faCircle, faCommentAlt, faSmile, faFrown, faMeh, faSquare} from '@fortawesome/free-regular-svg-icons'
import { faWordpress, faTumblr, faPinterest, faLinkedin, faTwitter, faWhmcs, faAffiliatetheme, faYoutube, faTwitch, faFacebook} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VoerroTagsInput from '@voerro/vue-tagsinput';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import '@voerro/vue-tagsinput/dist/style.css'
import 'leaflet/dist/leaflet.css';

import 'vue-instant/dist/vue-instant.css'
import VueInstant from 'vue-instant/dist/vue-instant.common'
import VueSocialSharing from 'vue-social-sharing'
import './ml'

Vue.use(VueSocialSharing);


Vue.component('tags-input', VoerroTagsInput);
 
library.add(faComment, faExclamation, faStopCircle, faPauseCircle, faPause, faMedal, faExternalLinkSquareAlt, faImage, faShare, faCut, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faEnvelope, faBackward, fasCircle, faCircle, faDotCircle, faUnlink, faKey, faUserTimes, faUserPlus, faCode, faIdCardAlt, faIdBadge, faWordpress, faTumblr, faPinterest, faLinkedin, faTwitter, faLock, faLockOpen, faDiceOne, faWhmcs, faUserTie, faUserFriends, faInfoCircle, faHighlighter, faHandPaper, faHandRock, faTools, faCommentDots, faComments, faCommentAlt, faAffiliatetheme, faProjectDiagram, faCheckCircle, faCalendarWeek, faCalendarMinus, faUpload, faArrowUp, faFileUpload, faWindowClose, 
  faCaretLeft, faReplyAll, faLevelDownAlt, faLevelUpAlt, faThList, faMinusSquare, faTimes, faPenSquare, faCaretSquareUp, faArrowCircleUp, 
  faCheck, faCheckSquare, faMinusCircle, faSlash, faTrash, faEnvelopeOpen, faTag, faBell, faFileExport, faNetworkWired,
  faBoxOpen, faBookReader, faBookOpen, faArrowAltCircleDown, faDownload, faListOl, faCircleNotch, faClipboardList,
  faSquare, faLongArrowAltDown, faFileAlt, faClipboard, faEdit, faUserEdit, faPen, faTags, faClock, faBan,
  faStopwatch, faHourglassHalf, faHourglassEnd, faEye, faEyeSlash, faFire, faWater, faPlus, faPlug, faExternalLinkAlt, faLeaf, 
  faDatabase, faUsers, faSpinner, faThumbsUp, faFilm, faSync, faSort, faExclamationCircle, faVideo,
  faSearch, faAngleDoubleDown, faAngleDoubleUp, faUser, faCaretRight, faCaretDown, faMinus, faDesktop, 
  faPlay, faChartLine, faSignOutAlt, faSignInAlt, faQuestionCircle, faSmile, faFrown, faMeh, faWifi,
  faExclamationTriangle, faClone, faStop, faCogs, faTrashAlt, faSortAlphaUp, faSortAlphaDown, faHistory,
  faSortNumericUp, faSortNumericDown, faTh, faList, faBars, faYoutube, faTwitch, faFacebook, faCloudUploadAlt, faFileVideo,
  faPencilAlt, faLink, faVolumeUp, faVolumeMute, faMicrophoneSlash, faMicrophone, faCog, faRedo, faRedoAlt, faSignal,
  faCircle, faRetweet, faArrowLeft, faStream, faDownload, faAngleDown, faAngleUp, faShoppingCart, faCreditCard);
 
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.component('downloadCsv', JsonCSV);
Vue.component('vue-timepicker', VueTimepicker);


Vue.use(VueClipboard)
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)
Vue.use(MSStreamAuth);
Vue.use(VueInstant)


Vue.config.productionTip = false

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    //router.replace(targetPath);
    console.log(targetPath)
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.Vue = Vue;
